import he from "he";
import { client } from "./client";
import type { SnipeItUser } from "./types";

export async function searchUsers(query: string): Promise<SnipeItUser[]> {
  if (!query) return [];
  const res = await client.get<{ total: number; rows: SnipeItUser[] }>("/api/v1/users", {
    params: { search: query, limit: 50, order: "asc" },
  });
  return (res.data.rows ?? []).map((user) => ({
    ...user,
    name: he.decode(user.name),
  }));
}
